import React, { useState } from "react";

import styled from "styled-components";
import { H5, P } from "../Texts";
import { PrimaryButton } from "../Buttons";
import AcceptRejectlModal from "../../organisms/AcceptRejectModal";

import { toastWarning } from "../../../shared/helpers";
import moment from "moment";

const SendInviteCardStyle = styled.div`
  border-radius: 3px;
  // width: ${(props) => props.width || "fit-content"};
  width: ${(props) => props.width || "333.67px"};
  // height: ${(props) => props.height || "360px"};
`;

export const SendInviteCard = ({ item, width, height }) => {
  const [showCaseModal, setShowCaseModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);

  const toggleModal = () => setShowCaseModal(!showCaseModal);
  const toggleRejectModal = () => setShowRejectModal(!showRejectModal);

  return (
    <SendInviteCardStyle
      width={width}
      height={height}
      className="bg-white py-5 px-8  hover:shadow-sm duration-300"
    >
      <div>
        <div className="">
          <div className="flex justify-between">
            <H5 color="#000000" fontSize="18px">
              {item?.initiative?.name}
            </H5>
          </div>

          <P className="mt-2" color="#00000099" fontSize="16px">
            By {item?.organization?.name}
          </P>

          <div className="mt-12">
            <div>
              <P color="#000000" fontSize="14px">
                Invite sent on {moment(item?.createddAt ?? new Date()).format("ll")}
              </P>
            </div>

            <div className="mt-4 flex justify-center gap-x-4">
              <PrimaryButton
                fontFamily="medium"
                className="flex-1"
                p="10px 20px"
                style={{
                  backgroundColor: "#31A574",
                  borderRadius: "4px",
                }}
                onClick={toggleModal}
              >
                Accept
              </PrimaryButton>

              <PrimaryButton.Light
                fontFamily="medium"
                p="10px 20px"
                className="flex-1"
                style={{
                  backgroundColor: "#FFDEDE",
                  borderRadius: "4px",
                  color: "#DF0303",
                }}
                onClick={toggleRejectModal}
              >
                Reject
              </PrimaryButton.Light>
            </div>
          </div>
        </div>
      </div>

      {showCaseModal && (
        <AcceptRejectlModal
          header="Accept Invitation"
          text={`Accept invitation to join ${item?.initiative?.name}`}
          cta="Accept"
          action={() => {
            toastWarning("Can not perform this action on Demo mode");
            toggleModal();
          }}
          closeModal={toggleModal}
        />
      )}

      {showRejectModal && (
        <AcceptRejectlModal
          header="Reject Invitation"
          text={`Reject invitation to join ${item?.initiative?.name}`}
          cta="Reject"
          action={() => {
            toastWarning("Can not perform this action on Demo mode");
            toggleRejectModal();
          }}
          closeModal={toggleRejectModal}
        />
      )}
    </SendInviteCardStyle>
  );
};
